import React from "react";
import { Map } from "immutable";
import { Select, SelectOption } from "@showitinc/showit-wc";

import AppConstants from "../constants/AppConstants";
import VideoYoutubeSettings from "./elementproperties/VideoYoutubeSettings";
import VideoVimeoSettings from "./elementproperties/VideoVimeoSettings";
import VideoAssetSettings from "./elementproperties/VideoAssetSettings";
import { initFormatter } from "../utils/PropertyFormatters";
import CustomizeEffects from "../app2components/panel/shared/CustomizeEffects";

const {
  UPDATE_ACTION_SET,
  VIDEO_TYPE_VIMEO,
  VIDEO_TYPE_YOUTUBE,
  VIDEO_TYPE_ASSET,
} = AppConstants;

const CONTENT_TYPE = "content.type";

const ElementPropertiesVideo = ({
  element,
  elementId,
  isLocked,
  theme,
  onPropUpdate,
  mappedElement,
  layout,
}) => {
  const _onTypeChange = (propInfo) => {
    onPropUpdate({
      ...propInfo,
      action: UPDATE_ACTION_SET,
      name: "content",
      // reset content when type value is unset
      value: !propInfo.value ? {} : { type: propInfo.value },
    });
  };

  const video = element.get("content", Map());
  const type = video.get("type");

  const { onChange: onTypeChange } = initFormatter(_onTypeChange);

  return (
    <>
      <Select
        disabled={isLocked}
        label="Type"
        onSISelect={onTypeChange(CONTENT_TYPE, type)}
        reserveContext
        shift="left"
        value={type}
      >
        <SelectOption value={VIDEO_TYPE_VIMEO}>Vimeo</SelectOption>
        <SelectOption value={VIDEO_TYPE_YOUTUBE}>YouTube</SelectOption>
        <SelectOption value={VIDEO_TYPE_ASSET}>Media Library</SelectOption>
      </Select>
      {type === VIDEO_TYPE_VIMEO && (
        <VideoVimeoSettings
          key="vimeo-settings"
          isLocked={isLocked}
          element={element}
          theme={theme}
          onPropChange={onPropUpdate}
        />
      )}
      {type === VIDEO_TYPE_YOUTUBE && (
        <VideoYoutubeSettings
          key="youtube-settings"
          isLocked={isLocked}
          element={element}
          onPropChange={onPropUpdate}
        />
      )}
      {type === VIDEO_TYPE_ASSET && (
        <VideoAssetSettings
          key="asset-settings"
          isLocked={isLocked}
          element={element}
          elementId={elementId}
          theme={theme}
          onPropChange={onPropUpdate}
        />
      )}
      <CustomizeEffects
        mappedElement={mappedElement}
        layout={layout}
        onPropUpdate={onPropUpdate}
        preparedElement={element}
      />
    </>
  );
};

export default ElementPropertiesVideo;
